import axios from "axios";
import { config } from "../config";

const endpoint = `${config.API}/v1/encryption-keys`;

export const listEncryptionKeys = (businessClient) => axios.get(endpoint, {
  params: businessClient ? { business_client: businessClient } : {},
}).then(({ data }) => data);
export const createEncryptionKey = (payload) => axios.post(endpoint, payload);
export const updateEncryptionKey = (id, payload) => axios.patch(`${endpoint}/${id}`, payload);
export const deleteEncryptionKey = (id) => axios.delete(`${endpoint}/${id}`);

export function encryptionError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join("; ");
  return "Não foi possível concluir a operação. Tente novamente.";
}
